export const LINKSECTION =
{
    WebMenu: 'Web-Menu',
    WebFooter: 'Web-Footer',
    WebPreFooter : 'Web-PreFooter'
}

export const LINKNAME =
{
    Version : 'MyK_Footer_Version',
    PrivacyPolicy: 'MyK_Footer_PrivacyPolicy',
    TermsofUse:'MyK_Footer_TermsofUse',
    Copyright: 'MyK_Footer_Copyright',
    PreFooterFleetManagement :'MyK_PreFooter_FleetManagement',
    PreFooterParts :'MyK_PreFooter_Parts',
    PreFooterOthers :'MyK_PreFooter_Others',
    PreFooterSocialNetworks :'MyK_PreFooter_SocialNetworks',
}

export const LINKTARGETNAME =
{
    MykWeb : 'Myk-Web',
    ExternalWeb: 'External-Web',
    ExternalFile:'External-File',
    ExternalYoutube: 'External-Youtubet',
    ExternalFacebook: 'External-Facebook',
    ExternalTwitter: 'External-Twitter',
    ExternalLinkedin: 'External-Linkedin',
}

export const QUICKLINKS =
{
    Report: 'Report',
    PartsBook: 'Parts Book',
    QuickReferenceGuide: 'Quick Reference Guide',
    RecommendedPartsList: 'Recommended Parts List',
    Notes: 'Notes & Attachments',
    CreateAlert: 'Create Alerts',
    OrderKowaKit: 'order kowa kit'
}

export const QUICKLINKSNAME =
{
    Report: 'Report',
    PartsBook: 'PartsBook',
    QuickReferenceGuide: 'QuickReferenceGuide',
    RecommendedPartsList: 'RecommendedPartsList',
    Notes: 'Notes',
    CreateAlert: 'CreateAlert',
    OrderKowaKit: 'OrderKowaKit'
}

export const ORDERSTATUS = {
    Pending: 'Pending',
    PendingAtDistributor: 'Pending at Distributor',
    OrderPlaced: 'Order Placed',
    Cancelled: 'Cancelled',
    Completed: 'Completed',
    Shipped: 'Shipped',
    PartiallyShipped: 'Partially Shipped'
}

export const ALERT_TYPES = {
    Abnormality: 'ABN',
    Maintenance: 'MAINT',
    Component: 'Component',
    FactoryCampaign: 'FC',
    Kowa: 'KOWA',
    KCPCoverage: 'KCPCoverage',
    ExcessiveEngineonHours: 'EEH',
    ExcessiveIdleTime: 'EIT',
    FuelConsumption: 'FuelConsumption',
    ExcessiveRegeneration: 'ER',
    TrendAlerts: 'TA',
    MyUtilization: 'MU'
}

export const EmailToLink = {
    Email: 'kris.dhelft@komatsu.eu',
    Subject: 'Request assistance from My Komatsu'
}

export const REGION = {
    Europe: "EUROPE",
    AmericaCorp: "KAC"
}

export const UserType = {
    Distributor: "Distributor",
    Customer: "Customer",
    Employee: "Employee",
    BookOnly: "bookonly"
}

export const OPMDocTypes = ["Electrical manual", "Mechanical manual", "Operator's Manual","Technology and software manual"]